var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "network",
    width: 33.3,
    height: 33.3,
    viewBox: "0 0 33.3 33.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M29.753,13.1a3.552,3.552,0,0,0-3.406,2.559H24.28a7.652,7.652,0,0,0-1.539-3.708L24.2,10.492a3.548,3.548,0,1,0-1.4-1.4L21.344,10.56a7.642,7.642,0,0,0-3.707-1.54V6.953a3.546,3.546,0,1,0-1.974,0V9.02a7.652,7.652,0,0,0-3.708,1.539L10.491,9.095a3.539,3.539,0,1,0-1.4,1.4l1.464,1.464A7.653,7.653,0,0,0,9.02,15.663H6.953a3.546,3.546,0,1,0,0,1.974H9.02a7.642,7.642,0,0,0,1.54,3.707L9.1,22.808a3.547,3.547,0,1,0,1.4,1.4l1.464-1.464a7.653,7.653,0,0,0,3.708,1.539v2.067a3.546,3.546,0,1,0,1.974,0V24.28a7.642,7.642,0,0,0,3.707-1.54L22.809,24.2a3.54,3.54,0,1,0,1.4-1.4L22.74,21.344a7.642,7.642,0,0,0,1.54-3.707h2.067A3.546,3.546,0,1,0,29.753,13.1Zm-9.87,2.139L16.3,18.59a.986.986,0,0,1-1.362-.014L13.4,17.084a.987.987,0,0,1,1.376-1.416l.861.837L18.536,13.8a.987.987,0,1,1,1.348,1.442Z",
    fill: "#4e3057"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.1e971734eb0ff3caacb70bd69425ec3f.svg";
export { ForwardRef as ReactComponent };